// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8f10adee","869":"bbc94dff"}[chunkId] + ".chunk.js";
};